export interface IInventoryEquipmentTypeOption {
  name: string;
  id: string;
}
